module.exports = __webpack_public_path__ + "static/media/screen-size.3e6d4231.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/AudienceBuilder/assets/screen-size.svg
// module id = 7629
// module chunks = 0